import React, { useState, useEffect } from 'react';
import { Grid, Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import reportslogo from "../../assets/images/reportslogo.png";
import Axios from 'axios';
import { getAuthToken, getFacilityId, getcompanyId } from "../../utility/tokenUtility";
import { ifacSecurityURL, MasterGraph } from "../../utility/apiURLS";
import moment from 'moment';
const Tcviewfile = ({ data, rowData }) => {
    const [state, setState] = useState('');
    const [filenameUrl, setFilenameUrl] = useState([]);
    const stateid = data[0]?.stateid;
    const facilityname = localStorage.getItem("FacilityName") || "";

    const handleState = async () => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };


            const response = await Axios.get(`${ifacSecurityURL}/api/secstatemasters/${stateid}`, config);

            const stateName = response.data?.statename || response.data?.state?.name || "Unknown";
            setState(response.data?.statename);



        } catch (error) {
            console.error("Error fetching state data:", error);
        }
    };

    useEffect(() => {
        if (stateid) {
            handleState();
        }
    }, [stateid]);
    // console.log(data, "data");

    const facilityAcknowledgedRoles = ["Engineer", "Technician", "FEMS Staff", "FMS H.O.D", "Nominated Person", "Others"];

    // Ensure data[0]?.signatures exists
    const signatureData = data[0]?.signatures || [];

    // Find specific signatures
    const userAcceptance = signatureData.find((sig) => sig.signDesc === "End-User");
    const vendorDelivered = signatureData.find((sig) => sig.signDesc === "Vendor");
    const facilityAcknowledged = signatureData.find((sig) => facilityAcknowledgedRoles.includes(sig.signDesc));

    useEffect(() => {

        const fetchSignatures = async () => {

            try {

                setFilenameUrl([]); //  clear old state

                const token = getAuthToken("id_token");

                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    responseType: "blob",
                };

                const signatures = data?.[0]?.signatures || [];

                const results = await Promise.all(

                    signatures.map(async (sig) => {

                        if (!sig.filename) return null;

                        const res = await Axios.get(
                            `${MasterGraph}/api/FileUpload/DownloadFile/${sig.filename}`,
                            config
                        );

                        const blobUrl = URL.createObjectURL(res.data);

                        return {
                            designation: sig.signDesc,
                            url: blobUrl,
                        };

                    })

                );

                setFilenameUrl(results.filter(Boolean));

            } catch (err) {
                console.log(err);
            }

        };

        if (data?.[0]?.signatures?.length) {
            fetchSignatures();
        }

    }, [data?.[0]?.id]);


    return (
        <Box
            sx={{
                p: "5mm",
                width: "200mm",
                minHeight: "297mm",
                backgroundColor: "#fff",
                boxSizing: "border-box"
            }}
        >



            {/* HEADER */}

            <Grid container justifyContent="space-between"  >

                <Grid item xs={5}>
                    <img
                        src={reportslogo}
                        style={{ width: 80 }}
                    />
                </Grid>
                <Grid item xs={7} textAlign="right">

                    <Typography
                        sx={{ fontSize: "12px", fontWeight: "bold" }}
                    >
                        {data[0]?.vendorName}
                    </Typography>

                    <Typography
                        sx={{ fontSize: "11px", mt: 2 }}
                    >
                        {data[0]?.vendorAddress}
                    </Typography>

                    <Typography
                        sx={{ fontSize: "11px" }}
                    >
                        Tel : {data[0]?.vendorTelePhone}
                    </Typography>

                </Grid>

            </Grid>


            {/* TITLE */}
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ mt: 2 }}
            >

                <Typography
                    sx={{
                        fontWeight: "bold",
                        fontSize: "15px",
                        letterSpacing: 0.5
                    }}
                >
                    T&C No : {data[0]?.testingcommissionno}
                </Typography>

            </Grid>

            <Box display="flex" justifyContent="center" mt={1}>

                <Box
                    style={{
                        backgroundColor: "#009999",
                        fontWeight: "bold",
                        padding: "2px",
                        border: "1px solid #ddd",
                        width: "100%",
                        fontSize: "20px",
                        color: "white",
                        textAlign: "center"
                    }}
                >
                    COMMISSIONING CERTIFICATE
                </Box>

            </Box>


            {/* DESCRIPTION */}
            <Box display="flex" justifyContent="center" mt={2}>
                <Typography>

                    This is to Certify that the Equipment/system/instrument
                    Specified below has been delivered, installed and commissioned accordingly.

                </Typography>

            </Box>

            {/* CENTER TABLE */}

            <Grid container justifyContent="center" mt={2}>

                <Grid item xs={12}>

                    <TableContainer component={Paper}>

                        <Table size="small">

                            <TableBody>
                                {/* HEADER */}

                                <TableRow>
                                    <TableCell
                                        colSpan={6}
                                        sx={{
                                            backgroundColor: "#009999",
                                            color: "white",
                                            fontWeight: "bold",
                                            fontSize: "14px"
                                        }}
                                    >
                                        Basic Details
                                    </TableCell>
                                </TableRow>


                                {/* NEW ROW */}

                                <TableRow>

                                    <TableCell
                                        sx={{
                                            border: 0,
                                            backgroundColor: "#f0f0f0"
                                        }}
                                    >
                                        <b>Asset No</b>
                                    </TableCell>

                                    <TableCell
                                        colSpan={3}
                                        sx={{
                                            border: 0,
                                            backgroundColor: "#f0f0f0"
                                        }}
                                    >

                                        <Typography
                                            sx={{
                                                fontWeight: "bold",
                                                fontSize: "14px"
                                            }}
                                        >
                                            {data[0]?.assetno}
                                        </Typography>

                                    </TableCell>

                                </TableRow>

                                <TableRow>

                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Service</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.service}
                                    </TableCell>
                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Department</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.departmentdesc}
                                    </TableCell>

                                </TableRow>


                                <TableRow>

                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Hospital</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {facilityname}
                                    </TableCell>
                                    {/* <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Finance Asset No</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.financeassetno}
                                    </TableCell> */}
                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Installation Date</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {moment(data[0]?.installationDate).format("DD/MM/YYYY")}
                                    </TableCell>

                                </TableRow>



                                <TableRow>



                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Commission Date</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {moment(data[0]?.commissionDate).format("DD/MM/YYYY")}
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Equipment</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.equipment}
                                    </TableCell>

                                </TableRow>



                                <TableRow>


                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Model / Serial</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.model} / {data[0]?.serialNo}
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Manufacturer</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.manufacture}
                                    </TableCell>

                                </TableRow>



                                <TableRow>



                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Warranty Period</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.warrentyperiod}
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Warranty Start</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {moment(data[0]?.warrentystartdate).format("DD/MM/YYYY")}
                                    </TableCell>

                                </TableRow>



                                <TableRow>



                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Warranty End</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {moment(data[0]?.warrentyenddate).format("DD/MM/YYYY")}
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Asset Lifespan</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.lifespan}
                                    </TableCell>

                                </TableRow>



                                <TableRow>



                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>P/O No</b>
                                    </TableCell>

                                    <TableCell style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.poNumber}
                                    </TableCell>
                                    <TableCell style={{ border: 0, backgroundColor: '#f0f0f0' }}>
                                        <b>Purchase Cost</b>
                                    </TableCell>

                                    <TableCell colSpan={3} style={{ border: 0, backgroundColor: "#f0f0f0" }}>
                                        {data[0]?.purchasecost}
                                    </TableCell>

                                </TableRow>




                            </TableBody>

                        </Table>

                    </TableContainer>

                </Grid>

            </Grid>

            <Box sx={{ mt: 2 }}>

                <TableContainer component={Paper}>

                    <Table size="small">

                        <TableBody>

                            {/* HEADER */}

                            <TableRow>
                                <TableCell
                                    colSpan={6}
                                    sx={{
                                        backgroundColor: "#009999",
                                        color: "white",
                                        fontWeight: "bold",
                                        fontSize: "14px"
                                    }}
                                >
                                    Signature
                                </TableCell>
                            </TableRow>


                            {/* TITLE */}

                            <TableRow>

                                <TableCell colSpan={2} align="center" style={{ backgroundColor: '#f0f0f0' }}><b>User</b></TableCell>
                                <TableCell colSpan={2} align="center" style={{ backgroundColor: '#f0f0f0' }}><b>Facility</b></TableCell>
                                <TableCell colSpan={2} align="center" style={{ backgroundColor: '#f0f0f0' }}><b>Vendor</b></TableCell>

                            </TableRow>


                            {/* NAME */}

                            <TableRow>

                                <TableCell sx={{ width: 80 }} style={{ backgroundColor: '#f0f0f0' }}><b>Name :</b></TableCell>
                                <TableCell sx={{ width: 120 }} >{userAcceptance?.signName}</TableCell>
                                <TableCell sx={{ width: 80 }} style={{ backgroundColor: '#f0f0f0' }}><b>Name :</b></TableCell>
                                <TableCell sx={{ width: 120 }} >{facilityAcknowledged?.signName}</TableCell>
                                <TableCell sx={{ width: 80 }} style={{ backgroundColor: '#f0f0f0' }}><b>Name :</b></TableCell>
                                <TableCell sx={{ width: 120 }} >{vendorDelivered?.signName}</TableCell>

                            </TableRow>


                            {/* DESG */}

                            <TableRow>

                                <TableCell style={{ backgroundColor: '#f0f0f0' }}><b>Desg :</b></TableCell>
                                <TableCell  >{userAcceptance?.signDesc}</TableCell>

                                <TableCell style={{ backgroundColor: '#f0f0f0' }}><b>Desg :</b></TableCell>
                                <TableCell >{facilityAcknowledged?.signDesc}</TableCell>

                                <TableCell style={{ backgroundColor: '#f0f0f0' }}><b>Desg :</b></TableCell>
                                <TableCell >{vendorDelivered?.signDesc}</TableCell>

                            </TableRow>


                            {/* DATE */}

                            <TableRow>

                                <TableCell style={{ backgroundColor: '#f0f0f0' }}><b>Date :</b></TableCell>
                                <TableCell >
                                    {userAcceptance?.signDate
                                        ? moment(userAcceptance.signDate).format("DD/MM/YYYY")
                                        : ""}
                                </TableCell>

                                <TableCell style={{ backgroundColor: '#f0f0f0' }}><b>Date :</b></TableCell>
                                <TableCell >
                                    {facilityAcknowledged?.signDate
                                        ? moment(facilityAcknowledged.signDate).format("DD/MM/YYYY")
                                        : ""}
                                </TableCell>

                                <TableCell style={{ backgroundColor: '#f0f0f0' }}><b>Date :</b></TableCell>
                                <TableCell >
                                    {vendorDelivered?.signDate
                                        ? moment(vendorDelivered.signDate).format("DD/MM/YYYY")
                                        : ""}
                                </TableCell>

                            </TableRow>

                            <TableRow>

                                {/* USER */}
                                <TableCell colSpan={2} align="center" sx={{ height: 100 }}>

                                    {
                                        filenameUrl
                                            .filter((file) => file.designation === "End-User")
                                            .map((file, index) => (

                                                <img
                                                    key={index}
                                                    src={file.url}
                                                    alt="User"
                                                    style={{
                                                        maxWidth: 120,
                                                        maxHeight: 100,
                                                        alignItems: "center",
                                                        objectFit: "contain"
                                                    }}
                                                />

                                            ))
                                    }

                                </TableCell>


                                {/* FACILITY */}
                                <TableCell colSpan={2} align="center">

                                    {
                                        filenameUrl
                                            .filter((file) => file.designation === "Technician")
                                            .map((file, index) => (

                                                <img
                                                    key={index}
                                                    src={file.url}
                                                    alt="Facility"
                                                    style={{
                                                        maxWidth: 120,
                                                        maxHeight: 100,
                                                        alignItems: "center",
                                                        objectFit: "contain"
                                                    }}
                                                />

                                            ))
                                    }

                                </TableCell>


                                {/* VENDOR */}
                                <TableCell colSpan={2} align="center">

                                    {
                                        filenameUrl
                                            .filter((file) => file.designation === "Vendor")
                                            .map((file, index) => (

                                                <img
                                                    key={index}
                                                    src={file.url}
                                                    alt="Vendor"
                                                    style={{
                                                        maxWidth: 120,
                                                        maxHeight: 100,
                                                        alignItems: "center",
                                                        objectFit: "contain"
                                                    }}
                                                />

                                            ))
                                    }

                                </TableCell>

                            </TableRow>

                        </TableBody>

                    </Table>

                </TableContainer>

            </Box>
            <Box sx={{ mt: 40 }}>
                <Grid></Grid>
                <Grid></Grid>
                <Grid></Grid>
            </Box>
            <Box sx={{ padding: '15px' }}>
                <Grid container spacing={2}>
                    {/* Logo */}
                    <Grid item xs={6}>
                        <img
                            src={reportslogo}
                            alt="logo"
                            style={{ width: 80 }}
                        />
                    </Grid>
                    {/* Title */}
                    <Grid item xs={12}>
                        <Typography
                            variant="h6"
                            align="center"
                            sx={{ fontWeight: 'bold', textDecoration: 'underline' }}
                        >
                            VENDOR TESTING AND COMMISSIONING CHECKLIST
                        </Typography>
                    </Grid>

                    {/* Instructions */}
                    <Grid item xs={12}>
                        <Typography variant="body2" align="center">
                            Please do bring the following items for T&amp;C
                        </Typography>
                    </Grid>

                    {/* Checklist Items */}
                    <Grid container spacing={1}>
                        {[
                            "Copy of Purchase Order (PO) & Quotation",
                            "Copy of Delivery Order and Invoice",
                            "Business Card",
                            "User Guide (Simple Guide)",
                            "Operation Manual (Hardcopy & Softcopy)",
                            "Service Manual (Hardcopy & Softcopy) (including service password, any item used for calibration or service)",
                            "Warranty Card (if any)",
                            "Electrical Safety Test (to be carried out by vendor on site during T&C)",
                            "All Testers’ Calibration Certificate (to be valid during T&C)",
                            "Test & Commissioning Certificate",
                            "Competency Certificate of Vendors from Manufacturer",
                            "Technical Training with Certificate for In-House Personnel",
                            "Medical Device Authority (MDA) Letter",
                            "Technical Specification Documents and Design and As-Built Drawings",
                            "PPM Schedules During Warranty Period",
                            "Application to Statutory Department for permission to install and obtain Quality Assurance Performance Certificate or Operating License for the equipment (where applicable).",
                            "Other documents that might be deemed necessary to carry out testing and commissioning. (i.e: MSDS, CSDS etc)"
                        ].map((item, index) => (
                            <React.Fragment key={index}>
                                <Grid item xs={10}>
                                    <div style={{ fontSize: "14px" }}>
                                        {index + 1}. {item}
                                    </div>
                                </Grid>
                                <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                    <input
                                        type="checkbox"
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            backgroundColor: "white",      // Inside color when unchecked
                                            accentColor: "white",          // Color when checked (in most modern browsers)
                                            border: "1px solid #ccc",
                                            cursor: "pointer",
                                        }}
                                    />
                                </Grid>
                            </React.Fragment>
                        ))}
                    </Grid>


                    {/* Notes Section */}
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <Typography variant="body2" sx={{ fontSize: "13px", fontStyle: "italic" }}>
                            All vendors need to register at security department before entering into hospital premises.
                            Any clarifications do not hesitate to contact Facility Engineering / Biomedical Engineering of respected hospital.
                        </Typography>
                    </Grid>

                </Grid>


            </Box>




        </Box>
    );
};

export default Tcviewfile